"use strict";

jQuery(document).ready(function ($) {
  var $step1 = $('#step-1-products');
  var $step2 = $('#step-2-details');
  var $continueButton = $('#continue-to-step-2');

  /**
   * Detect browser refresh
   */
  function isBrowserRefresh() {
    if (window.performance && window.performance.navigation) {
      return window.performance.navigation.type === 1;
    }
    if (window.performance && window.performance.getEntriesByType) {
      var navEntry = window.performance.getEntriesByType('navigation')[0];
      return navEntry && navEntry.type === 'reload';
    }
    return false;
  }
  if (isBrowserRefresh()) {
    sessionStorage.removeItem('gq_in_flow');
  }
  var inFlow = sessionStorage.getItem('gq_in_flow');

  /**
   * Reset all product selections
   */
  function resetAllFields() {
    $('.get-quote__product--check').prop('checked', false).each(function () {
      this.checked = false;
    });
    $('.get-quote__product--qty input').val('').each(function () {
      this.value = '';
    });
    $('.get-quote__product--qty').removeClass('get-quote__open');
    $('.get-quote__accordion').removeClass('get-quote__open');
    $('.get-quote__section-container').hide();
    $('[data-custom-id="get-quote__items"]').val('');
    $continueButton.prop('disabled', true);
  }

  /**
   *
   */
  if (!inFlow) {
    localStorage.removeItem('gq_step1_selections');
    $('html').removeClass('gq-has-errors');
    $('.gform_validation_error').removeClass('gform_validation_error');
    $('.validation_error').removeClass('validation_error').hide();
    $('.gfield_error').removeClass('gfield_error');
    $('.validation_message').hide();
    $step1.show();
    $step2.hide();
    resetAllFields();
    setTimeout(resetAllFields, 100);
    setTimeout(resetAllFields, 500);
  }

  /**
   *
   */
  if (inFlow) {
    var hasGfErrors = $step2.find('.gform_validation_error, .validation_error, .gfield_error').length > 0;
    var hasConfirmation = $step2.find('.gform_confirmation_message').length > 0;
    if (hasConfirmation) {
      // Form completed → exit flow
      localStorage.removeItem('gq_step1_selections');
      sessionStorage.removeItem('gq_in_flow');
      $step1.hide();
      $step2.show();
    } else if (hasGfErrors) {
      // Errors → show step 2 with error message
      $step1.hide();
      $step2.show();
      restoreStep1Selections();
    } else {
      restoreStep1Selections();
    }
  }

  /**
   * Save Step 1 selections to localStorage
   */
  function saveStep1Selections() {
    var selections = [];
    $('.get-quote__product--check:checked').each(function () {
      var $product = $(this).closest('.get-quote__product');
      var $qtyInput = $product.find('.get-quote__product--qty input');
      var productName = $qtyInput.attr('name');
      var productQty = $qtyInput.val();
      if (productName) {
        selections.push({
          name: productName,
          qty: productQty
        });
      }
    });
    if (selections.length > 0) {
      localStorage.setItem('gq_step1_selections', JSON.stringify(selections));
    }
  }

  /**
   * Restore Step 1 selections from localStorage
   */
  function restoreStep1Selections() {
    var savedSelections = localStorage.getItem('gq_step1_selections');
    if (savedSelections) {
      try {
        var selections = JSON.parse(savedSelections);
        selections.forEach(function (selection) {
          var $input = $('input[name="' + selection.name + '"]');
          if ($input.length) {
            var $product = $input.closest('.get-quote__product');
            var $checkbox = $product.find('.get-quote__product--check');
            var $qtyField = $product.find('.get-quote__product--qty');
            $checkbox.prop('checked', true);
            $qtyField.addClass('get-quote__open');
            $input.val(selection.qty);
            var $accordion = $product.closest('.get-quote__accordion');
            var $container = $accordion.find('.get-quote__section-container');
            $container.css('display', 'block');
            $accordion.addClass('get-quote__open');
          }
        });
        checkProductSelection();
      } catch (e) {
        //   console.error('Error restoring selections:', e);
      }
    }
  }

  /**
   * Accordion toggle
   */
  $('.get-quote__accordion').each(function () {
    var $accordion = $(this);
    var $section = $accordion.find('.get-quote__section');
    var $container = $accordion.find('.get-quote__section-container');
    $section.on('click', function () {
      var isOpen = $accordion.hasClass('get-quote__open');
      $container.stop(true, true).slideToggle(250, function () {
        if (!isOpen) $(this).css('display', 'block');
      });
      $accordion.toggleClass('get-quote__open', !isOpen);
    });
  });

  /**
   * Check product selection for button state
   */
  function checkProductSelection() {
    var $checkedProducts = $('.get-quote__product--check:checked');
    var isAnyProductChecked = $checkedProducts.length > 0;
    var allRequiredFieldsFilled = true;
    if (isAnyProductChecked) {
      $checkedProducts.each(function () {
        var $productQtyInput = $(this).closest('.get-quote__product').find('.get-quote__product--qty input');
        if ($productQtyInput.length && (!$productQtyInput.val() || parseFloat($productQtyInput.val()) <= 0)) {
          allRequiredFieldsFilled = false;
        }
      });
    }
    $continueButton.prop('disabled', !(isAnyProductChecked && allRequiredFieldsFilled));
    return isAnyProductChecked && allRequiredFieldsFilled;
  }

  /**
   * Product checkbox handling
   */
  $('.get-quote__product--check').each(function () {
    var $productCheck = $(this);
    var $product = $productCheck.closest('.get-quote__product');
    var $productTxt = $product.find('.get-quote__product--text');
    var $productQty = $product.find('.get-quote__product--qty');
    var $productQtyInput = $productQty.find('input');
    $productTxt.on('click', function () {
      $productCheck.trigger('click');
    });
    $productCheck.on('change', function () {
      $productQty.toggleClass('get-quote__open');
      if ($productQty.hasClass('get-quote__open')) {
        $productQtyInput.addClass('input-focus').focus();
      } else {
        $productQtyInput.removeClass('input-focus input-error').val(null).trigger('focusout');
      }
      checkProductSelection();
    });
    $productQtyInput.on('blur', function () {
      $(this).removeClass('input-focus');
    }).on('focus', function () {
      $(this).addClass('input-focus');
    });
  });

  /**
   * Update hidden field with product list
   */
  $('.get-quote__product--qty input').each(function () {
    var $item = $(this);
    $item.on('focusout', function () {
      var listItems = '';
      $('.get-quote__product--qty.get-quote__open input').each(function () {
        var $itemUpdate = $(this);
        var itemName = $itemUpdate.data('item-name');
        var itemValue = $itemUpdate.val();
        if (itemValue && itemValue.trim() !== '') {
          listItems += itemName + ' || Sqm2 =  ' + itemValue + '\r\n';
        }
      });
      $('[data-custom-id="get-quote__items"]').val(listItems).trigger('change');
      checkProductSelection();
    });
    $item.on('input', checkProductSelection);
  });
  checkProductSelection();

  /**
   * Continue to Step 2
   */
  $continueButton.on('click', function () {
    $('.get-quote__product--qty input').removeClass('input-error');
    if (checkProductSelection()) {
      sessionStorage.setItem('gq_in_flow', 'true');
      saveStep1Selections();
      $('.gform_validation_error').removeClass('gform_validation_error');
      $('.validation_error').removeClass('validation_error').hide();
      $('.gfield_error').removeClass('gfield_error');
      $('.validation_message').hide();
      $('html').removeClass('gq-has-errors');
      $step1.slideUp(400);
      $step2.slideDown(400, function () {
        $('html, body').animate({
          scrollTop: $step2.offset().top - 100
        }, 500);
      });
    } else {
      var $firstError = null;
      $('.get-quote__product--check:checked').each(function () {
        var $productQtyInput = $(this).closest('.get-quote__product').find('.get-quote__product--qty input');
        if ($productQtyInput.length && (!$productQtyInput.val() || parseFloat($productQtyInput.val()) <= 0)) {
          $productQtyInput.addClass('input-error');
          if (!$firstError) $firstError = $productQtyInput;
        }
      });
      if ($firstError) {
        $firstError.removeClass('input-focus');
        $('html, body').animate({
          scrollTop: $firstError.offset().top - 100
        }, 500);
        $firstError.focus();
      }
    }
  });

  /**
   * Back button
   */
  document.addEventListener('click', function (e) {
    var backButton = e.target.closest('#back-to-step-1, .get-quote__submit--back');
    if (backButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $('html').removeClass('gq-has-errors');
      $('.gform_validation_error').removeClass('gform_validation_error');
      $('.validation_error').removeClass('validation_error');
      $('.gfield_error').removeClass('gfield_error');
      $step1.attr('style', 'display: block !important');
      $step2.attr('style', 'display: none !important');
      $('.get-quote__product--check:checked').each(function () {
        var $product = $(this).closest('.get-quote__product');
        var $accordion = $product.closest('.get-quote__accordion');
        var $container = $accordion.find('.get-quote__section-container');
        var $qtyField = $product.find('.get-quote__product--qty');
        $container.css('display', 'block');
        $accordion.addClass('get-quote__open');
        $qtyField.addClass('get-quote__open');
      });
      checkProductSelection();
      $('[data-custom-id="get-quote__items"]').prop('readonly', true);
      $('html, body').animate({
        scrollTop: $step1.offset().top - 100
      }, 500);
      return false;
    }
  }, true);
});

// Safety net: window.onload runs AFTER browser restores form values
window.addEventListener('load', function () {
  // Check if refresh
  var isRefresh = false;
  if (window.performance && window.performance.navigation) {
    isRefresh = window.performance.navigation.type === 1;
  } else if (window.performance && window.performance.getEntriesByType) {
    var navEntry = window.performance.getEntriesByType('navigation')[0];
    isRefresh = navEntry && navEntry.type === 'reload';
  }
  var inFlow = sessionStorage.getItem('gq_in_flow');
  if (isRefresh || !inFlow) {
    if (isRefresh) sessionStorage.removeItem('gq_in_flow');
    jQuery('.get-quote__product--check').prop('checked', false).each(function () {
      this.checked = false;
    });
    jQuery('.get-quote__product--qty input').val('').each(function () {
      this.value = '';
    });
    jQuery('.get-quote__product--qty').removeClass('get-quote__open');
    jQuery('.get-quote__accordion').removeClass('get-quote__open');
    jQuery('.get-quote__section-container').hide();
    jQuery('#continue-to-step-2').prop('disabled', true);
    jQuery('#step-1-products').show();
    jQuery('#step-2-details').hide();
  }
});